
import React, { SyntheticEvent } from 'react';
import Card from 'react-bootstrap/Card';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';

import { DELETE_ARTICLE_CONFIRMATION_MSG } from '../globals';

type ArticleCardProps = {
  id?: string
  href?: string,
  imageSrc?: string,
  title?: string,
  editMode: boolean,
  className?: string,
  btnClickHandler: (e: any) => void,
  deleteBtnHandler: (id: string) => void,
}

const ArticleCard: React.FunctionComponent<ArticleCardProps> = ({
  id,
  href,
  imageSrc,
  title,
  editMode,
  btnClickHandler,
  deleteBtnHandler,
  className,
}) => (
  <Card
    as="a"
    href={href}
    className={
      `bg-light text-dark article-card ${ editMode ? 'editable' : '' } ${className || ''}`
    }
    onClick={btnClickHandler}
  >
    <Card.Img src={imageSrc}
      alt="Card image"
      className="image-responsive article-card__image"
    />
    <Card.ImgOverlay
      className="article-card__overlay"
    >
      <Card.Title
        className="article-card__title"
      >
        {title}
      </Card.Title>
      {
        editMode
          ? <Card.Footer className="article-card__footer">
              <button
                className="btn btn-danger"
                title="Delete this article"
                onClick={(e: SyntheticEvent) => {
                  e.stopPropagation();
                  if (id) {
                    const confirmed = window.confirm(DELETE_ARTICLE_CONFIRMATION_MSG);
                    if (confirmed){ deleteBtnHandler(id) }
                  }
                }}
              >
                <FontAwesomeIcon icon={faTrashAlt} />
              </button>
            </Card.Footer>
          : ''
      }
    </Card.ImgOverlay>
  </Card>
)

export default ArticleCard;